import { attachTabSync } from '@rocketlane/state-db';
import { getTabSync } from '../tab-sync';
import { buildMergedTasks, taskCollection } from './task-collection';
/**
 * Bind the task collection to the cross-tab channel.
 *
 * Peer payloads go through `buildMergedTasks`, the same no-downgrade merge the
 * local ingest path uses. A raw push would be actively harmful here: the tab
 * that broadcast the change may hold a LIGHTER copy of the task than this one
 * (a plan-board list row versus an open detail drawer), and replacing wholesale
 * would strip the detail-only fields and the `fields[]` option metadata that
 * only this tab has.
 *
 * Returns a detach function; safe to call when BroadcastChannel is unavailable
 * (the underlying `TabSync` no-ops).
 */ export const attachTaskTabSync = ()=>attachTabSync({
        collection: taskCollection,
        sync: getTabSync(),
        apply: (entities, push)=>push(buildMergedTasks(entities))
    });
